// Base
import type { AppProps } from 'next/app'

import 'yard-utilities/styles/globals.css'
// Swiper styles
import 'swiper/scss'
import 'swiper/scss/pagination'
import 'swiper/scss/navigation'
// Global styles
import '@styles/globals.sass'

// Redux
import { Provider as ReduxProvider } from 'react-redux'
import { useStore } from '@redux/store'

// Auth
import { SessionProvider } from 'next-auth/react'

// Components
import Wrapper from '@components/app/Wrapper'

export default function App({ Component, pageProps }: AppProps) {
  const store = useStore(pageProps.initialReduxState)

  return (
    <ReduxProvider store={store}>
      <SessionProvider session={pageProps.session}>
        <Wrapper>
          <Component {...pageProps} />
        </Wrapper>
      </SessionProvider>
    </ReduxProvider>
  )
}
